export { default } from "./billingInstallmentCard";
